import { IconProps } from './index';

const ThumbUpFill: React.VFC<IconProps> = ({ title, titleId, ...props }) => {
    return (
        <svg
            width="1em"
            height="1em"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-labelledby={titleId}
            {...props}
        >
            {title ? <title id={titleId}>{title}</title> : null}
            <path
                d="M1.166 5.25h1.75v7h-1.75a.583.583 0 01-.583-.583V5.833a.583.583 0 01.583-.583zm3.088-.754L7.987.762A.292.292 0 018.37.735l.497.373a.875.875 0 01.323.916l-.673 2.643h3.734a1.167 1.167 0 011.166 1.166v1.228c0 .152-.03.303-.087.444l-1.806 4.384a.583.583 0 01-.54.361H4.667a.583.583 0 01-.583-.583V4.908c0-.155.062-.303.17-.412z"
                fill="currentColor"
            />
        </svg>
    );
};

export default ThumbUpFill;
